"use client";

import { FC } from "react";
import ReactModal from "react-modal";

import s from "./Modal.module.scss";

interface Props {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

export const Modal: FC<Props> = ({ open, onClose, children }) => (
  <ReactModal
    isOpen={open}
    contentLabel="Gallery"
    className={s.Modal}
    overlayClassName={s.Overlay}
    preventScroll
    shouldCloseOnEsc
    onRequestClose={() => onClose()}
  >
    {children}
    <button type="button" className={s.Close} onClick={() => onClose()}>
      +
    </button>
  </ReactModal>
);
